module.exports = __webpack_public_path__ + "img/giles-ketting-unknown.d55e22d.jpg";